import AlbumFolderInnerPageHeader from './AlbumFolderInnerPageHeader';

export default AlbumFolderInnerPageHeader;
